export const API_V1_URI = "/api/v1";
export const ACCOUNT_API_LOGIN = API_V1_URI + "/accounts/login";
export const ACCOUNT_API_PROFILE = API_V1_URI + "/accounts/profile";
export const ACCOUNT_API_PASSWORD = API_V1_URI + "/accounts/update-password";
export const ACCOUNT_API_UPDATE = API_V1_URI + "/accounts/update-profile";
export const ACCOUNT_API_FORGOT_PASSWORD =
  API_V1_URI + "/accounts/forgot-password";
export const ACCOUNT_API_RESET_PASSWORD =
  API_V1_URI + "/accounts/reset-password";
export const ACCOUNT_API_VERIFY_PHONE = API_V1_URI + "/accounts/verify-phone";
export const ACCOUNT_API_REFRESH_TOKEN = API_V1_URI + "/accounts/refresh-token";
export const ACCOUNT_API_SIGN_UP_PHONE = API_V1_URI + "/accounts/sign-up-phone";
export const ACCOUNT_API_SIGN_IN_PHONE = API_V1_URI + "/accounts/sign-in-phone";
export const CUSTOMER_ADDRESS_API = API_V1_URI + "/client/customer_addresses";
export const ADDRESS_API = API_V1_URI + "/addresses";
export const PROVINCE_API = ADDRESS_API + "/provinces";
export const DISTRICT_API = ADDRESS_API + "/districts";
export const WARD_API = ADDRESS_API + "/wards";
export const SHOPPING_CART_API = API_V1_URI + "/client/shopping-cart";
export const SHOPPING_CART_API_ADD_ITEM = SHOPPING_CART_API + "/create-item";
export const SHOPPING_CART_API_REMOVE_ITEM = SHOPPING_CART_API + "/remove-item";
export const SHOPPING_CART_API_UPDATE_ITEM = SHOPPING_CART_API + "/update-item";
export const SHOPPING_CART_API_UPDATE_ADDRESS =
  SHOPPING_CART_API + "/update-address";
export const SHOPPING_CART_API_APPLY_COUPON =
  SHOPPING_CART_API + "/apply-coupon";
export const SHOPPING_CART_API_REMOVE_COUPON =
  SHOPPING_CART_API + "/remove-coupon";
export const SHOPPING_CART_API_CREATE_ORDER =
  SHOPPING_CART_API + "/create-order";
export const ORDER_API = API_V1_URI + "/client/customer_orders";
export const SHOPPING_WEBSITE_CART_API = API_V1_URI + "/website/shopping-cart";
export const SHOPPING_WEBSITE_ADD_ITEMS_CART_API = SHOPPING_WEBSITE_CART_API + "/add-items";
export const SHOPPING_WEBSITE_UPDATE_ITEM_CART_API = SHOPPING_WEBSITE_CART_API + "/update-item";
export const SHOPPING_WEBSITE_REMOVE_ITEM_CART_API = SHOPPING_WEBSITE_CART_API + "/remove-item";
export const SHOPPING_WEBSITE_APPLY_COUPON_CART_API = SHOPPING_WEBSITE_CART_API + "/apply-coupon";
export const SHOPPING_WEBSITE_REMOVE_COUPON_CART_API = SHOPPING_WEBSITE_CART_API + "/remove-coupon";